import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface RemoveItemData extends Types.IApi.RemoveItem.Request {
  collectionId: string;
}

const useRemoveItem = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ collectionId, ...data }: RemoveItemData) => {
      await Api.removeItem(collectionId, data);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collections', 'single', variables.collectionId] });
      queryClient.invalidateQueries({ queryKey: ['collections', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['collections', 'owned'] });
      if (variables.type === 'test') queryClient.invalidateQueries({ queryKey: ['test'] });
      toast.success('Item removed', {
        description: 'Item has been removed from the collection.',
      });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to remove item',
      });
    },
  });
};

export default useRemoveItem;
